<template>
    <div class="p-4">
        <div class="p-4 bg-white testimonies">
            <img :src="require(`@/assets/KOVATEK/IMAGES/${image}`)" style="width:90px; height:90px" class="mt-4 " />
            <p class="ctrl-size mt-3">{{testimony}}</p>
            <p class="kova-text font-weight-bolder mt-3 mb-0">{{name}}</p>
            <p class="ctrl-size">{{company}}</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'testimony',
    props: {
        image: String,
        testimony: String,
        name: String,
        company: String
    },
    data(){
        return {

        }
    }
}
</script>

<style scoped>
.testimonies{
    border: solid 1px #90adff;
}
.ctrl-size{
    font-size: 12px;
}
</style>